export const formItemList = [
    {
        labelName: "估价单号",
        key: 'channelAssessNo',
        type: "input",
        lableWidth: "80px",
        placeholder: "请输入订单编号",
    },
    {
        labelName: "回收单号",
        key: 'recycleOrderNo',
        type: "input",
        placeholder: "请输入订单编号",
    },
    {
        labelName: "估价门店",
        key: 'storeId',
        type: "selectFilterable",
        placeholder: "请先选择门店商家",
        lableWidth: '80px',
        clear: true,
        option: [],
        disabled: true,
        clearFun: () => false
    },
    {
        labelName: "估价店员",
        key: 'staffName',
        type: "input",
        placeholder: "请输入下单店员姓名",
    },
    {
        labelName: "回收分类",
        key: 'typeId',
        type: "selectFilterable",
        placeholder: "请选择分类",
        lableWidth: '80px',
        clear: true,
        option: [],
        clearFun: () => false
    },
    // 旧机情况
    {
        key: 'healthCode',
        type: 'select',
        lableWidth:'80px',
        labelName: '机况分类',
        option: [],
    },
    {
        labelName: "回收商品",
        key: 'machineName',
        type: "input",
        placeholder: "请输入商品名称",
    },
    {
        labelName: "是否关联回收下单",
        key: 'isBuildRecycle',
        type: "selectFilterable",
        placeholder: "请选择关联回收下单方式",
        lableWidth: '160px',
        clear: true,
        option: [
            {
                label: '全部',
                value: null
            },
            {
                label: '是',
                value: '02'
            },
            {
                label: '否',
                value: "01"
            }
        ],
        clearFun: () => false
    },
    {
        lableWidth: "80px",
        labelName: "下单时间",
        key: 'time',
        type: "daterange",
    },
]

export const tableDatas = {
    // 加载
    loading:false,
    // 当前数据
    currentData:{},
    // 表数据
    data:[],
    // 单数
    allCount:0,
    // 表列
    tableColumns:[
        {
            prop: "index",
            label: "序号",
            width: "60px"
        },
        {
            prop: "channelAssessNo",
            label: "估价单号",
        },
        {
            prop: "createTime",
            label: "估价时间",
        },
        {
            prop: "companyName",
            label: "门店商户",
        },
        {
            prop: "staffName",
            label: "估价店员",
        },
        {
            prop: "typeName",
            label: "旧机分类",
        },
        {
            prop: "brandName",
            label: "旧机品牌",
        },
        {
            prop: "machineName",
            label: "估价机型",
        },
        {
            prop: "report",
            label: "验机报告",
        },
        {
            prop:"healthName",
            label:"机况分类"
        },
        {
            prop: "showPrice",
            label: "显示预估价",
        },
        {
            prop: "channelPrice",
            label: "原始预估价",
        },
        {
            prop: "recycleOrderNo",
            label: "关联回收单号",
        },
        {
            prop: "maxQuotePrice",
            label: "回收单最高报价",
        },
    ]
}

// 估价单验机报告弹窗
export const dialogProps = {
    title:"初步验机报告",
    show:false,
    width:'40%',
    report:{},
    // 旧机信息
    infoData:{},
    // 检测项
    tableData:[
        {
            one:"1",
            two:"2",
            three:"3"
        },
        {
            one:"1",
            two:"2",
            three:"3"
        }
    ]
}
// 预估价明细
export const detailDialogPorps = {
    show:false,
    title:"预估价明细",
    width:'30%',
}
